import { AbstractInteractionMode, DrawModeOption, DrawStyleUtil } from "./abstract-interaction-mode";
import { VueComponentControl } from "../control/VueComponentControl";
import MapGeocoderControl from "../../../components/map/controls/MapGeocoderControl.vue";
import { MapEvent } from "../../document/model/map";
import { LocationPickerTranslatePoint } from "../draw-modes/location-picker/location-picker-translate-point";
import { Feature, Geometry, MultiPolygon, Polygon } from "geojson";
import { LayerGeometry } from "../../document/model/layer";
import {
  LocationPickerPointTransformTranslate
} from "../interaction/location-picker/location-picker-point-transform-translate";

export class LocationPickerMode extends AbstractInteractionMode {
  static identifier: string = "location-picker";
  static title: string = "Locatie";
  static icon: string = "/icons/toolbox/address.svg";

  static actionBarSize: 'small' | 'large' | undefined = 'small';
  static actionBarShowLabels = true;

  static drawStyles = DrawStyleUtil.drawStyle({
    "line-color": '#23B402',
    "border-color": '#23B402',
  });

  static defaultInteraction: string = 'point_transform_translate';

  static drawModes: DrawModeOption[] = [
    new DrawModeOption('point_transform_translate', LocationPickerTranslatePoint),
  ];

  static interactions = {
    'point_transform_translate': LocationPickerPointTransformTranslate.definition()
  }

  private _control: VueComponentControl;
  private _tmpGeometriesSubscriber;

  onInit() {
    if (!this._control) {
      this._control = new VueComponentControl(MapGeocoderControl, { expanded: true, autoAdd: true })
      this._mapInstance.addControl(this._control, 'top-left');
    }
    this._tmpGeometriesSubscriber = (event: { features }) => {
      this.controller.interaction.clearTmpGeometries(event.features.map(feature => feature.id));
      this.controller.interaction.mode.resetInteraction();
      this.controller.mapInstance.fire(MapEvent.Tick);
    };
    this._mapInstance.on(MapEvent.TmpGeometryCreated, this._tmpGeometriesSubscriber);
  }

  onDestroy() {
    this._mapInstance.removeControl(this._control);
    this._mapInstance.off(MapEvent.TmpGeometryCreated, this._tmpGeometriesSubscriber);
    this._control = undefined;
    super.onDestroy();
  }
}
